import {
  Component,
  ContentChildren,
  HostBinding,
  Input,
  QueryList,
} from '@angular/core';
import { TableCellHeaderComponent } from '../table-cell-header/table-cell-header.component';

@Component({
  selector: 'opac-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss']
})
export class TableRowComponent {
  private isHeaderRow = false;

  /**
   * References all cell header components and checks if this row is header if exists any cell header inside
   */
  @ContentChildren(TableCellHeaderComponent) set headers(value: QueryList<TableCellHeaderComponent>) {
    this.isHeaderRow = value?.length > 0 ?? false;
  }

  /**
   * Determines if row should be hoverable
   */
  @HostBinding('class.hoverable')
  isHoverable: boolean = false;

  /**
   * Determines if table scrollTop > 0
   */
  @HostBinding('class.scrolling')
  isScrolling: boolean = false;

  /**
   * Add special class to header rows
   */
  @HostBinding('class.header-row')
  get classHeaderRow() {
    return this.isHeaderRow;
  }

  /**
   * Determines if this row should be sticky
   */
  @HostBinding('class.sticky') @Input() sticky = false;
}
